import RestrictedPage from "@/consumer/restrictedPage";
import AccessFailureLogTable from "@/components/accessFailureLog/accessFailureLogTable";

export default function AccessFailureLogList() {
  return (
    <RestrictedPage permissionRequired="frontend_view_accessfailurelog">
      <AccessFailureLogTable />
    </RestrictedPage>
  );
}
